import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Select,
  Input,
  PageHeader,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useSearchParams } from "react-router-dom";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { useUserNameValidation } from "../../../hooks/useUserNameValidation";
import FormItem from "antd/lib/form/FormItem";
import { useNavigate } from "react-router";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import { editRole, getRole } from "../../../Services/notifications&rolesServices";
import axios from "axios";

const accessOptions = [
  { label: "Edit", value: "edit" },
  { label: "View", value: "view"},
];
const accessOptions2 = [
  { label: "Edit", value: "edit" },
  { label: "View", value: "view", disabled: true },
];

const accessOptionsForProd = [
  { label: "View", value: "view", },
];

const accessAllOptions = [
  { label: "View All", value: "view_all" },
  { label: "View Own", value: "view_own" },
  { label: "Edit All", value: "edit_all" },
  { label: "Edit Own", value: "edit_own" },
];
const approveOptions = [{ label: "Approve", value: "approve" }];

const EditRole = (props) => {
  let [searchParams] = useSearchParams();
  const source = axios.CancelToken.source();
  const [alert, setAlert] = useState(false);
  const [warningMsg, setWarningMsg] = useState();
  const [message, setMessage] = useState();
  const [visible, setVisible] = useState(false);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [roleDetails, setRoleDetails] = useState();
  const [prevCheckBoxValues,setPrevCheckBoxValues] = useState();
  const [orderManagementSettings,setOrderMangementSettings] = useState();

  const onChange = (checkedValues,formItemName) => {
    let data=checkedValues;
    if(prevCheckBoxValues[formItemName]?.includes("view") && !checkedValues?.includes("view"))
    {
      data=[];
    }
    if(!prevCheckBoxValues[formItemName]?.includes("edit") && checkedValues?.includes("edit"))
    {
      data=["view","edit"];
    }
    if(!prevCheckBoxValues[formItemName]?.includes("edit_own") && checkedValues?.includes("edit_own"))
    {
      data=[...checkedValues,"view_own"];
    }
    if(prevCheckBoxValues[formItemName]?.includes("view_own") && !checkedValues?.includes("view_own"))
    {
      data=checkedValues.filter(item=>item!="edit_own");
    }
    if(!prevCheckBoxValues[formItemName]?.includes("edit_all") && checkedValues?.includes("edit_all"))
    {
      data=[...checkedValues,"view_all"];
    }
    if(prevCheckBoxValues[formItemName]?.includes("view_all") && !checkedValues?.includes("view_all"))
    {
      data=checkedValues.filter(item=>item!="edit_all");
    }
    form.setFieldsValue({[formItemName]:data});
    setPrevCheckBoxValues({
      ...prevCheckBoxValues,
      [formItemName]:data,
    })
  };

  // const setBasicUserRoles = () => {
  //   form.setFieldsValue({
  //     user_management: [],
  //   });
  //   // console.log("role", form.getFieldValue("user_management"));
  // };

  const accessControlData = (data) => {
    let array2 = [];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        if (value === true) array2.push(String(key));
      });
      return array2;
    } else return [];
  };

  const showCancelModal = () => {
    setVisible(true);
  };

  const closeCancelModal = () => {
    setVisible(false);
  };

  const confirmCancelModal = () => {
    form.resetFields();
    setVisible(false);
    navigate("../roles-and-permissions")
  };

  const onHandleCancel = () => {
    showCancelModal();
  };

  const onHandleSave = () => {
    form.submit();
  };

  //Function to return the value of view and edit inside access controls
  const accessControlValue = (value, prodKey, approveJobCardValue = []) => {
    if (value){
      if(prodKey){
        return {
          view: value.includes("view") || value.includes("edit") || approveJobCardValue.includes("approve"),
        };
      } else{
      return {
        view: value.includes("view") || value.includes("edit") || approveJobCardValue.includes("approve"),
        edit: value.includes("edit") && value.includes("view"),
      };
    }
    }else{
      if(prodKey){
        return {
          view: false,
        };
      } else{
        return {
          view: false,
          edit: false,
        };
      }
    }
  };
  //Fuction to return the value of view own,view all,edit own and edit all inside access controls
  const accessControlOrderRecordCheck = (value, approveOrdersValue) => {
    if (value) {
      return {
        view_own: value.includes("view_own") || value.includes("edit_own") || approveOrdersValue.includes("approve"),
        view_all: value.includes("view_all") || value.includes("edit_all") || approveOrdersValue.includes("approve"),
        edit_own: value.includes("edit_own")  && value.includes("view_own"),
        edit_all: value.includes("edit_all") && value.includes("view_all"),
      };
    } else
      return {
        view_own: false,
        view_all: false,
        edit_own: false,
        edit_all: false,
      };
  };

  const onFinish = async (values) => {
    const body = {
      name: values.roleName.toUpperCase(),
      roles: {
        approve_jobcards: {
          edit: values.approve_jobcards?.includes("approve"),
          view: values.approve_jobcards?.includes("approve"),
        },
        approve_orders: {
          edit: values.approve_orders?.includes("approve"),
          view: values.approve_orders?.includes("approve"),
        },
        global_settings: accessControlValue(values.global_settings),
        machine_records: accessControlValue(values.machine_records),
        product_records: accessControlValue(values.product_records),
        customer_records: accessControlValue(values.customer_records),
        workflow_settings: accessControlValue(values.workflow_settings),
        advanced_settings: accessControlValue(values.advanced_settings),
        order_records: accessControlOrderRecordCheck(values.order_records, "" ,values.approve_orders),
        job_cards: accessControlValue(values.job_cards, "" ,values.approve_jobcards),
        company_profile: accessControlValue(values.company_profile),
        user_management: accessControlValue(values.user_management),
        plan_details_and_billing: accessControlValue(
          values.plan_details_and_billing
        ),
        notifications:accessControlValue(values.notifications),
        production: {
          job_cards: accessControlValue(values.production_job_cards),
          jumbo_reels: accessControlValue(values.jumbo_reels),
          prod_details: accessControlValue(values.prod_details,"productionDetails"),
        },
        packaging_config: accessControlValue(values.packaging_config),
        inventory: {
          stocks: accessControlValue(values.stocks),
        },
      },
    };
    try {
      const updatedRole = await editRole(searchParams.get("name"),body);
      setAlert(true);
      setWarningMsg(false);
    //   setMessage(updatedRole?.msg);
      setMessage("Role updated successfully");
      setTimeout(() => {
        navigate("/organization-setting/roles-and-permissions/",{
          state: { response: updatedRole.data }
        });
      }, 1800);
    } catch (error) {
      setAlert(true);
      setWarningMsg(true);
      setMessage("Error while updating role");
    }
  };
    const fetchRoleData = async() =>{
      try{
        const role = await getRole(searchParams.get("name"),source);
        setRoleDetails(role);
        setPrevCheckBoxValues(
        {
            global_settings:accessControlData(role.roles.global_settings),
            machine_records:accessControlData(role.roles.machine_records),
            product_records:accessControlData(role.roles.product_records),
            customer_records:accessControlData(role.roles.customer_records),
            workflow_settings:accessControlData(role.roles.workflow_settings),
            advanced_settings:accessControlData(role.roles.advanced_settings),
            packaging_config:accessControlData(role.roles.packaging_config),
            order_records:accessControlData(role.roles.order_records),
            approve_orders:role.roles?.approve_orders?.edit ? ["approve"]: [],
            job_cards:accessControlData(role.roles.job_cards),
            approve_jobcards:role.roles?.approve_jobcards?.edit ? ["approve"]: [],
            company_profile:accessControlData(role.roles.company_profile),
            user_management:accessControlData(role.roles.user_management),
            plan_details_and_billing:accessControlData(role.roles.plan_details_and_billing),
            production_job_cards:accessControlData(role.roles.production_job_cards),
            jumbo_reels:accessControlData(role.roles.jumbo_reels),
            prod_details:accessControlData(role.roles.prod_details),
            stocks:accessControlData(role.roles.inventory.stocks),
        }
        )
        const orderMangSettings = await getWorkflowSettings("order_management");
        setOrderMangementSettings(orderMangSettings)
      }
      catch(e)
      {
        console.log(e);
      }
    } 


    useEffect(() => {
      fetchRoleData();
      return () => source.cancel();
    }, []);

  return roleDetails ? (
    <Form>
      {alert ? (
        <AlertContainer
          color={warningMsg ? "red" : "green"}
          icon={warningMsg ? alertRed : alertGreen}
          msg={message}
        />
      ) : (
        ""
      )}
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Edit Role"
            extra={[
              <Button key="1" className="textTypeBtn" onClick={onHandleCancel}>
                Cancel changes
              </Button>,
              <Button
                key="2"
                className="themeBtn"
                onClick={onHandleSave}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Save
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <DetailFields>
          {roleDetails ? (
            <HaberForm>
              <div className="groupDetailWrap">
                <Form
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin"
                  onFinish={onFinish}
                  onFinishFailed={(error) => {
                    console.log("Form Error", error);
                  }}
                  initialValues={{
                    remember: true,
                  }}
                >
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>General Details</h2>
                        <p>Enter general details of the role</p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                            <div className="boxFieldTitle">
                              <label>Role Name</label>
                              <p>Enter the name you want to assign to the role</p>
                            </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              initialValue={roleDetails?.name?.replaceAll("_"," ")}
                              name="roleName"
                              rules={[
                                { required: true }
                              ]}
                              className=""
                            >
                              <Input
                                disabled={["SALES_COORDINATOR","DECKLE_PLANNER","PLANT_OPERATOR"].includes(roleDetails?.name)}
                                placeholder="Enter role name"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row
                    gutter={[24, 24]}
                    className="groupForm"
                    style={{ borderBottom: "0px" }}
                  >
                    <Col span={8}>
                      <GroupTitle style={{ marginTop: "10px" }}>
                        <h2>Access Control</h2>
                        <p>This user will have access to selected modules</p>
                      </GroupTitle>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Configurations</h2>
                        <p>
                          User access to configurations can be controlled here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Global Settings</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="global_settings"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.global_settings
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"global_settings")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Machine Records</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="machine_records"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.machine_records
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"machine_records")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Product Records</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="product_records"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.product_records
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"product_records")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Customer Records</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="customer_records"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.customer_records
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"customer_records")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Workflow Settings</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="workflow_settings"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.workflow_settings
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"workflow_settings")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Advanced Settings</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="advanced_settings"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.advanced_settings
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"advanced_settings")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Packaging Type</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="packaging_config"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.packaging_config
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"packaging_config")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Order Management</h2>
                        <p>
                          User access to order management can be controlled here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Order Records</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="order_records"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.order_records
                              )}
                            >
                              <Checkbox.Group
                                options={accessAllOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"order_records")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Approve Orders</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="approve_orders"
                              className=""
                              initialValue={
                                roleDetails?.roles?.approve_orders?.edit
                                  ? ["approve"]
                                  : []
                              }
                            >
                              <Checkbox.Group
                                options={approveOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Deckle Management</h2>
                        <p>
                          User access to deckle management can be controlled
                          here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Job Cards</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="job_cards"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.job_cards
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"job_cards")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Approve Job Cards</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="approve_jobcards"
                              className=""
                              initialValue={
                                roleDetails?.roles?.approve_jobcards?.edit
                                  ? ["approve"]
                                  : []
                              }
                            >
                              <Checkbox.Group
                                options={approveOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Organization Settings</h2>
                        <p>
                          User access to organization settings can be controlled
                          here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Company Profile</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="company_profile"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.company_profile
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"company_profile")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>User Management</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="user_management"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.data?.roles?.user_management
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"user_management")}
                                className="flexRowReverse"
                                disabled={
                                  roleDetails?.data?.role_type === "BASIC"
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Plan Details and Billing</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <FormItem
                              name="plan_details_and_billing"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles
                                  ?.plan_details_and_billing
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"plan_details_and_billing")}
                                className="flexRowReverse"
                              />
                            </FormItem>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Notifications</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="notifications"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.notifications
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions2}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"notifications")}
                                className="flexRowReverse"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Production Planning</h2>
                        <p>
                          User access to production planning can be controlled
                          here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Job Cards</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="production_job_cards"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.production?.job_cards
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                className="flexRowReverse"
                                onChange={(checkedValues)=>onChange(checkedValues,"production_job_cards")}
                                disabled={
                                  orderManagementSettings?.data?.fetch_orders_from_erp?.value
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Jumbo Reels</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="jumbo_reels"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.production
                                  ?.jumbo_reels
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptions}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"jumbo_reels")}
                                className="flexRowReverse"
                                disabled={
                                  orderManagementSettings?.fetch_orders_from_erp?.value
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Production Details</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item
                              name="prod_details"
                              className=""
                              initialValue={accessControlData(
                                roleDetails?.roles?.production
                                  ?.prod_details
                              )}
                            >
                              <Checkbox.Group
                                options={accessOptionsForProd}
                                // checked={isChecked}
                                // onChange={onChange}
                                onChange={(checkedValues)=>onChange(checkedValues,"prod_details")}
                                className="flexRowReverse"
                                disabled={
                                  orderManagementSettings?.fetch_orders_from_erp?.value
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Stock Management</h2>
                        <p>
                          User access to stock management can be controlled here
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign titleVCenter paddingTB">
                        <Col span={24}>
                          <div className="boxFieldTitle ant-col-8">
                            <label>Stock Records</label>
                          </div>
                          <div className="boxFormType reverseCheckbox">
                            <Form.Item name="stocks"
                              initialValue={accessControlData(
                                roleDetails?.roles?.inventory?.stocks
                              )}                            
                            >
                              <Checkbox.Group
                                options={accessOptions.map((option)=>{
                                  if(option.value == 'edit')
                                    return {
                                      ...option,
                                      disabled:true,
                                    }
                                  else
                                    return option
                                })}
                                // defaultValue={["View"]}
                                // checked={isChecked}
                                onChange={(checkedValues)=>onChange(checkedValues,"stocks")}
                                className="flexRowReverse"
                                disabled={
                                  orderManagementSettings?.data?.fetch_orders_from_erp?.value
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </HaberForm>
          ) : (
            ""
          )}
        </DetailFields>

        <ConfirmationModal
          visible={visible}
          icon={warning}
          confirmAction={confirmCancelModal}
          cancelAction={closeCancelModal}
        >
          <span>Are you sure?</span>
          <p>
            You have pending changes on this page, are you sure you want to
            leave?
          </p>
        </ConfirmationModal>
      </RightLayoutContainer>
    </Form>
  ) : (
    <></>
  );
};

export default EditRole;
